import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const shouldRetryRequest = (failureCount: number, error: unknown) => {
  if (error instanceof AxiosError) {
    const status = error.response?.status;

    if (status === 401 || status === 403 || status === 404) {
      return false;
    }
  }

  return failureCount < 2;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      gcTime: 1000 * 60 * 5,
      retry: shouldRetryRequest,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});
